import { cn } from '@restworld/utils-common';
import { SkeletonLoadingProps, variantMap } from './skeleton-loading.constants';
import { loadingText } from './skeleton-loading.components';

export const SkeletonLoading = ({ variant, animation = true }: SkeletonLoadingProps) => (
  <div className={cn('w-full', animation && 'animate-pulse')}>
    {variantMap[variant]}
    {loadingText}
  </div>
);
export default SkeletonLoading;
export * from './skeleton-loading.components';
export * from './skeleton-element-loading';
